export default __webpack_public_path__ + "static/media/starFilled.b010726c.svg";